import DefaultTab from "./@types/DefaultTab";

export const DEFAULT_TABS: DefaultTab[] = ["INTRO", "PRE", "VIDEO", "POS"];

export const TYPOGRAPHY_TEXT_CENTRALIZE = {
  display: "flex",
  alignItems: "center",
};
